var map = {
	"./american-express-mono.svg": "b799",
	"./american-express.svg": "0b6b",
	"./diners-club-mono.svg": "1202",
	"./diners-club.svg": "a060",
	"./discover-mono.svg": "f8ac",
	"./discover.svg": "b6c3",
	"./jcb-mono.svg": "820c",
	"./jcb.svg": "c69b",
	"./mastercard-mono.svg": "6eb2",
	"./mastercard.svg": "0be0",
	"./unionpay-mono.svg": "61c5",
	"./unionpay.svg": "6849",
	"./visa-mono.svg": "89fd",
	"./visa.svg": "4c1f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";